import {
  StoreWasteStatisticsState,
  REQUEST_STOREWASTESTATISTICS,
  REQUEST_STOREWASTESTATISTICS_DONE
} from "./types";

const initialState: StoreWasteStatisticsState = {
  isLoading: true,
  storeWasteStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_STOREWASTESTATISTICS:
      return {
        isLoading: true,
        storeWasteStatistics: action.payload
      };
    case REQUEST_STOREWASTESTATISTICS_DONE:
      return {
        isLoading: false,
        storeWasteStatistics: action.payload
      };
    default:
      return state;
  }
}
